import styled from 'styled-components';

import { Button } from 'app/theme/Button';
import { Icon } from 'app/theme/Icons/Icon';
import { breakpoint } from 'app/theme/theme';
import { common } from 'app/translations/dictionary';
import { DialogWithImage } from 'pkg/components/DialogWithImage';

interface HttpErrorDialogProps {
  onClose: () => void;
  message?: string;
}

const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  max-height: 80%;
  align-items: center;
  justify-content: space-between;

  ${breakpoint.up.sm`
      padding-right: 3rem;
  `}
`;

const AlertTitle = styled.p`
  font-size: 2rem;
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primary};
  padding-bottom: 1rem;
  a {
    color: ${({ theme }) => theme.palette.primary};
    text-decoration: underline;
    word-break: break-word;
  }

  ${breakpoint.up.sm`
    font-size: 2.8rem;
  `}
  ${breakpoint.up.md`
    padding-bottom: 3rem;
    font-size: 3rem;    
    margin-bottom: 0.6rem;
  `}

  ${breakpoint.up.lg`
    font-size: 3.5rem;    
  `}
`;

const ErrorIcon = styled(Icon)`
  &&&& {
    font-size: 10rem;
    color: ${({ theme }) => theme.palette.primary};
    margin-bottom: 2rem;

    ${breakpoint.up.sm`
      margin-bottom: 0;
      font-size: 18rem;
    `}
  }
`;

const TryAgainButton = styled(Button)`
  &&&& {
    font-size: 1.6rem;
    margin-top: 1rem;
    padding: 1rem 2rem;
    height: 5rem;
  }
`;

export const ErrorDialog = ({ onClose, message = common.errorMessage }: HttpErrorDialogProps): JSX.Element => (
  <DialogWithImage image={<ErrorIcon name="exclamation triangle" />} onClose={onClose}>
    <Container>
      <AlertTitle dangerouslySetInnerHTML={{ __html: message }} />
      <TryAgainButton onClick={onClose} primary>
        {common.tryAgain}
      </TryAgainButton>
    </Container>
  </DialogWithImage>
);
